module.exports = __webpack_public_path__ + "static/Image02@2x-22ddda2239803e3592b604d179e416b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image02@2x.jpg
// module id = 895
// module chunks = 227233210825294 244429959259914